var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUploadInactive = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 21,
    r: 19,
    fill: "#B6BDC1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_48_5729)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.1747 17.328L21.1497 13.464C20.8413 13.168 20.4163 13 19.9747 13H13.9997C13.083 13 12.3413 13.72 12.3413 14.6L12.333 27.4C12.333 28.28 13.0747 29 13.9913 29H23.9997C24.9163 29 25.6663 28.28 25.6663 27.4V18.464C25.6663 18.04 25.4913 17.632 25.1747 17.328ZM21.333 23.4H19.833V25.8C19.833 26.24 19.458 26.6 18.9997 26.6C18.5413 26.6 18.1663 26.24 18.1663 25.8V23.4H16.6747C16.2997 23.4 16.1163 22.968 16.383 22.72L18.7163 20.488C18.883 20.336 19.1413 20.336 19.308 20.488L21.633 22.72C21.883 22.968 21.6997 23.4 21.333 23.4ZM20.6663 18.6C20.208 18.6 19.833 18.24 19.833 17.8V14.2L24.4163 18.6H20.6663Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_48_5729"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(11 13)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUploadInactive);
export default ForwardRef;